import { render, staticRenderFns } from "./BrandsAddLayer.vue?vue&type=template&id=6ce513ff&scoped=true&"
import script from "./BrandsAddLayer.vue?vue&type=script&lang=js&"
export * from "./BrandsAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandsAddLayer.vue?vue&type=style&index=0&id=6ce513ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce513ff",
  null
  
)

export default component.exports